<template>
  <div class="content">
    
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <img src="../assets/images/nav_img1.jpg" oncontextmenu="return false;"/>
    </div>
    <div class="main">
      <div style="margin-top: 1rem;">
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path:getid.routername }">{{getid.pagename}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{getid.currentpage}}</el-breadcrumb-item>
        </el-breadcrumb> -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Panorama' }">精选效果图列表</el-breadcrumb-item>
          <el-breadcrumb-item>效果图预览列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="main-img" v-for="(item,index) in datas" :key="index">
        <div class="main-title">{{item.roomname}}</div>
        <div class="bran-father">
          <img :src="item.img" oncontextmenu="return false;"/>
          <div class="brand" >桔家云</div>
        </div>
      </div>
    </div>
    <div style="height:3rem;"></div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
export default {
  components: {
  
    BottomFoot,
    Rightnav,
    Freequote
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "桔家云、装修案例、装修参考、整装、婚房、单身公寓、装修效果图、100平、三口之家、儿童房桔家云整装，上千个装修案例实景分享，业主精心总结装修攻略，新中式、简欧、美式等各种风格案例，尽在桔家云整装。"
        }
      ]
    };
  },
  data() {
    return {
      showquote: false,
      topnub: 0,
      nub: "7",
      current: 0,
      datas: [],
      getid: ""
    };
  },
  methods: {
    getshow(data) {
      //console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    postdetails: async function() {
      this.getid = this.$route.query.id;
      let data = {
        designid: this.getid
      };
      let res = await this.exequy.ctdetails(data);
      this.datas = res.data.data;
    }
  },
  created: async function() {
    let self = this;
    self.postdetails();
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
}
.banane {
  width: 100%;
  height: 340px;
  
}
.banane img {
  width: 100%;
  height: 100%;
}
.main-img {
  width: 100%;
}
.main-img img {
  width: 100%;
  height: 100%;
}
.main-title {
  text-align: left;
  padding-top: 1rem;
  font-size: 25px;
}
.bran-father{
  position: relative;
}
.brand{
 width:12%; 
 height:50px; 
 background:#b31d25;
 position:absolute;
 top: 0px;
 right: 0px;
 color: #fff;
 line-height: 50px;
 font-size: 25px;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
